import { render, staticRenderFns } from "./FormRecord.vue?vue&type=template&id=a6597b76&scoped=true&"
import script from "./FormRecord.vue?vue&type=script&lang=js&"
export * from "./FormRecord.vue?vue&type=script&lang=js&"
import style0 from "./FormRecord.vue?vue&type=style&index=0&id=a6597b76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6597b76",
  null
  
)

export default component.exports